export function createBaseEvent(type, action, data) {
  return {
    type,
    action,
    data,
    date: new Date().toISOString(),
  };
}
